import React from 'react';
import { Field } from 'redux-form';

import { HONEYPOT_NAME, HONEYPOT_STYLE } from './constants';

const Input: React.FC<{ input: React.InputHTMLAttributes<HTMLInputElement> }> =
  ({ input }) => <input {...input} style={HONEYPOT_STYLE} />;

const Honeypot: React.FC = () => (
  <Field type="text" name={HONEYPOT_NAME} component={Input} />
);

export default Honeypot;
